import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
// components
import { Col } from '../../../../foundations/Grid';

export const SectionStyledDisclaimerContainer = styled.section`
  ${({ disableDisclaimerTopBorder, theme }) => css`
    margin-top: ${disableDisclaimerTopBorder ? 0 : rem(32)};
    padding-top: ${rem(16)};
    padding-bottom: ${rem(16)};
    /** disclaimer section will have top border unless disabled */
    border-top: ${disableDisclaimerTopBorder ? 'none' : `${rem(1)} solid ${theme.colors.neutral.gray}`};
    border-bottom: ${rem(1)} solid ${theme.colors.neutral.gray};
  `}
`;

export const ColStyledCustomDisclaimer = styled(Col)`
  ${({
    combinedCustomFootnotesCharacterCount,
    characterCountThreshold,
    theme,
  }) => {
    let thisColumnCount = 1;
    const mediumUp = theme.mediumUp();
    if (mediumUp && combinedCustomFootnotesCharacterCount > characterCountThreshold) {
      thisColumnCount = 2;
    }
    return css`
      && {
        padding-top: ${rem(16)};
        padding-bottom: ${rem(32)};
        column-count: ${thisColumnCount};
        /** TODO: convert this to a Link prop variant? */
        .nmx-link {
          font-size: ${rem(14)};
          line-height: ${rem(22)};
          font-weight: 500;
        }
      }
    `;
  }}
`;
